"use client";

import dynamic from "next/dynamic";
import { Suspense } from "react";

/**
 * 把 Analytics、AppBanner、NavigationProgress 包進 dynamic({ ssr: false }) 客端 chunk,
 * 從 initial JS bundle 中移除以縮短 TBT / Long Task。
 *
 * 為什麼要這個 wrapper:
 *   - layout.tsx 是 Server Component,Next 16 不支援在 Server Component 內
 *     對 dynamic() 傳 { ssr: false }(會被忽略)。
 *   - 所以開一個小型 'use client' wrapper,讓 dynamic 可以真正延後到 hydrate 後執行。
 *
 * 顯示行為:
 *   - Analytics 永遠回 null,無視覺影響(只送 GA event)。
 *   - AppBanner 原本就是 'use client' 元件,SSR 也只給空殼骨架,延後到客端
 *     才渲染,在使用者眼中與原本「掛載後才出現」沒差。
 *   - NavigationProgress 預設 visible=false 不出 DOM,延後 mount 對使用者唯一
 *     可感知的差別是「第一次點 Link 後極短暫間 (chunk 載完前) 沒有 progress bar」,
 *     但本來 progress bar 也只在動畫執行中才看得到,影響極小。
 */
const Analytics = dynamic(() => import("@/components/Analytics"), { ssr: false });
const AppBanner = dynamic(() => import("@/components/AppBanner"), { ssr: false });
const NavigationProgress = dynamic(() => import("@/components/NavigationProgress"), { ssr: false });

export default function DeferredClientFeatures() {
  return (
    <>
      <Suspense fallback={null}>
        <Analytics />
      </Suspense>
      <NavigationProgress />
      <AppBanner />
    </>
  );
}
